module.exports = __webpack_public_path__ + "d46d6c3c7b78afca6f776a06527a068a.png";